import classes from './ResultsFooter.module.scss'
import type { ReactNode } from 'react'

export interface Props {
  children: ReactNode
}

const ResultsFooter = ({
  children
}: Props) =>
  <div className={classes.ResultsFooter}>
    {children}
  </div>

export default ResultsFooter
